import {ExtraReducer, ReducerFromState} from "../../../@types/reducers";

export const isInitialized = (state: ReducerFromState<ExtraReducer>): boolean => state.extra.initializing;